import type { UserEvent } from "@/services/api/cronos/user/events/get-all"

export default function isLocked(event: UserEvent): boolean {
  return event.parent.createdBy === "university"
}
